import type { CSSObject } from '@emotion/react'
import { ReactNode } from 'react'

export enum HeadingSize {
  small = 'small',
  medium = 'medium',
  large = 'large',
  xLarge = 'xLarge',
}

export type HeadingProps = Readonly<{
  className?: string
  id?: string
  level?: 1 | 2 | 3 | 4 | 5 | 6
  overrideStyles?: CSSObject
  size?: HeadingSize
  // It seems like this has to be declared, even though the component is typed
  // as `FunctionComponent`, which automatically provides `children`.
  children: ReactNode
}>
